<div class="card">
    <div class="card-header bg-blue-grey-400">
        Ventilation Source
    </div>
    <div class="card-body">
        <div class="mh-16 mv-8 w-400">
            <div class="mb-3">
                <label for="ventilationType" class="form-label">Ventilation Type</label>
                <select class="form-select" [(ngModel)]="VentilationDetails.ventilationType" [disabled]="!isEdit" [ngModelOptions]="{standalone: true}">
                    <option *ngFor="let option of ventilationTypes" [value]="option">
                        {{ option }}
                    </option>
                </select>
            </div>
        </div>
        <div class="mh-16 mv-8 w-400">
            <div class="mb-3">
            <label for="mechanicalVentDatabase" class="form-check-label">Product from database?</label>
            <input id="mechanicalVentDatabase" class="form-check-input form-check-inline" [(ngModel)]="VentilationDetails.mechanicalVentDatabase" type="checkbox" [disabled]="!isEdit" [ngModelOptions]="{standalone: true}">
            </div>
        </div>
        <div class="mh-16 mv-8 w-400">
            <div class="mb-3">
            <label for="mechanicalVentIndexNumber" class="form-label">Index Number</label>
            <input id="mechanicalVentIndexNumber" class="form-control" type="number" min="0" [(ngModel)]="VentilationDetails.mechanicalVentIndexNumber" [disabled]="!isEdit" [ngModelOptions]="{standalone: true}">
            </div>
        </div>
        <div class="mh-16 mv-8 w-400">
            <div class="mb-3">
            <label for="wetRoomsCount" class="form-label">Number of wet rooms</label>
            <input id="wetRoomsCount" class="form-control" type="number" min="0" [(ngModel)]="VentilationDetails.wetRoomsCount" [disabled]="!isEdit" [ngModelOptions]="{standalone: true}">
            </div>
        </div>
        <div class="mh-16 mv-8 w-400">
            <div class="mb-3">
                <label for="mechanicalVentDuctType" class="form-label">Duct Type</label>
                <select id="mechanicalVentDuctType" class="form-select" [(ngModel)]="VentilationDetails.mechanicalVentDuctType" [disabled]="!isEdit" [ngModelOptions]="{standalone: true}">
                    <option *ngFor="let option of ventDuctType" [value]="option">
                        {{ option }}
                    </option>
                </select>
            </div>
        </div>
        <div class="mh-16 mv-8 w-400">
            <div class="mb-3">
                <label for="mechanicalVentDuctPlacement" class="form-label">Duct Placement</label>
                <select id="mechanicalVentDuctPlacement" class="form-select" [(ngModel)]="VentilationDetails.mechanicalVentDuctPlacement" [disabled]="!isEdit" [ngModelOptions]="{standalone: true}">
                    <option *ngFor="let option of ventDuctPlacement" [value]="option">
                        {{ option }}
                    </option>
                </select>
            </div>
        </div>
        <div class="mh-16 mv-8 w-400">
            <div class="mb-3">
                <label for="mechanicalVentDuctInsulation" class="form-label">Duct Insulation</label>
                <select id="mechanicalVentDuctInsulation" class="form-select" [(ngModel)]="VentilationDetails.mechanicalVentDuctInsulation" [disabled]="!isEdit" [ngModelOptions]="{standalone: true}">
                    <option *ngFor="let option of ventDuctInsulation" [value]="option">
                        {{ option }}
                    </option>
                </select>
            </div>
        </div>
        <div class="mh-16 mv-8 w-400">
            <div class="mb-3">
                <label for="mechanicalVentDuctInsulationLevel" class="form-label">Duct Insulation Level</label>
                <select id="mechanicalVentDuctInsulationLevel" class="form-select" [(ngModel)]="VentilationDetails.mechanicalVentDuctInsulationLevel" [disabled]="!isEdit" [ngModelOptions]="{standalone: true}">
                    <option *ngFor="let option of ventDuctInsulationLevel" [value]="option">
                        {{ option }}
                    </option>
                </select>
            </div>
        </div>
        <div class="mh-16 mv-8 w-400">
            <div class="mb-3">
            <label for="mechanicalVentKitchenRoomFans" class="form-label">Kitchen Room Fans</label>
            <input id="mechanicalVentKitchenRoomFans" class="form-control" type="number" min="0" [(ngModel)]="VentilationDetails.mechanicalVentKitchenRoomFans" [disabled]="!isEdit" [ngModelOptions]="{standalone: true}">
            </div>
        </div>
        <div class="mh-16 mv-8 w-400">
            <div class="mb-3">
            <label for="mechanicalVentNonKitchenRoomFans" class="form-label">Non-Kitchen Room Fans</label>
            <input id="mechanicalVentNonKitchenRoomFans" class="form-control" type="number" min="0" [(ngModel)]="VentilationDetails.mechanicalVentNonKitchenRoomFans" [disabled]="!isEdit" [ngModelOptions]="{standalone: true}">
            </div>
        </div>
        <div class="mh-16 mv-8 w-400">
            <div class="mb-3">
            <label for="mechanicalVentKitchenDuctFans" class="form-label">Kitchen Duct Fans</label>
            <input id="mechanicalVentKitchenDuctFans" class="form-control" type="number" min="0" [(ngModel)]="VentilationDetails.mechanicalVentKitchenDuctFans" [disabled]="!isEdit" [ngModelOptions]="{standalone: true}">
            </div>
        </div>
        <div class="mh-16 mv-8 w-400">
            <div class="mb-3">
            <label for="mechanicalVentNonKitchenDuctFans" class="form-label">Non-Kitchen Duct Fans</label>
            <input id="mechanicalVentNonKitchenDuctFans" class="form-control" type="number" min="0" [(ngModel)]="VentilationDetails.mechanicalVentNonKitchenDuctFans" [disabled]="!isEdit" [ngModelOptions]="{standalone: true}">
            </div>
        </div>
        <div class="mh-16 mv-8 w-400">
            <div class="mb-3">
            <label for="mechanicalVentKitchenWallFans" class="form-label">Kitchen Wall Fans</label>
            <input id="mechanicalVentKitchenWallFans" class="form-control" type="number" min="0" [(ngModel)]="VentilationDetails.mechanicalVentKitchenWallFans" [disabled]="!isEdit" [ngModelOptions]="{standalone: true}">
            </div>
        </div>
        <div class="mh-16 mv-8 w-400">
            <div class="mb-3">
            <label for="mechanicalVentNonKitchenWallFans" class="form-label">Non-Kitchen Wall Fans</label>
            <input id="mechanicalVentNonKitchenWallFans" class="form-control" type="number" min="0" [(ngModel)]="VentilationDetails.mechanicalVentNonKitchenWallFans" [disabled]="!isEdit" [ngModelOptions]="{standalone: true}">
            </div>
        </div>
        <div class="mh-16 mv-8 w-400">
            <div class="mb-3">
            <label for="mechanicalVentMeasuredInstallation" class="form-check-label">Measured installation?</label>
            <input id="mechanicalVentMeasuredInstallation" class="form-check-input form-check-inline" [(ngModel)]="VentilationDetails.mechanicalVentMeasuredInstallation" type="checkbox" [disabled]="!isEdit" [ngModelOptions]="{standalone: true}">
            </div>
        </div>
        <div class="mh-16 mv-8 w-400">
            <div class="mb-3">
            <label for="mechanicalVentApprovedInstallation" class="form-check-label">Installed through approved scheme?</label>
            <input id="mechanicalVentApprovedInstallation" class="form-check-input form-check-inline" [(ngModel)]="VentilationDetails.mechanicalVentApprovedInstallation" type="checkbox" [disabled]="!isEdit" [ngModelOptions]="{standalone: true}">
            </div>
        </div>
    </div>
</div>
